import { mutateAll } from '@/store/utils'
import { createInitialState } from './index'

export const setCurrentUser = (state, user) => {
  state.currentUser = user
}

export const setUserGroups = (state, userGroups) => {
  state.currentUserGroups = userGroups || []
}

export const setUserCookies = (state, cookies) => {
  state.currentUser.cookies = cookies
}

export const setCarrierPartnerManager = (state, contact) => {
  state.partnerManager = contact
}

export const setVehicleTypes = (state, payload) => {
  state.vehicleTypes = payload
}

export const setTeamMembers = (state, payload) => {
  state.teamMembers = payload
}

export const setShouldReloadState = (state, payload) => {
  state.shouldReload = payload
}

export const setOpenAssignmentsCount = (state, payload) => {
  state.openAssignmentsCount = payload
}

export const reset = state => {
  mutateAll(state, createInitialState())
}

export const setCarrierCompany = (state, payload) => {
  state.currentCarrierCompany = payload
}

export const setCurrentUserLanguage = (state, language) => {
  state.currentUser.uiLanguage = language
}

export const setCarrierCompanyPaymentDays = (state, payload) => {
  state.currentCarrierCompany.carrierPaymentDays = payload
}

export const setIsBannerOpen = (state, isBannerOpen) => {
  state.isBannerOpen = isBannerOpen
}
